export class UserKpiMasterViewModel {
    mappingId: number;
    kpiId: number;
    userEmailId: string;
    canShowInDashboard: boolean;
    createdBy: string;
    createdOn?: Date;
    updatedBy: string;
    updatedOn?: Date;
    displayText: string;
    descriptionText?: string;
    displayOrder: number;
    suffix?: string;
    isDefault: boolean;
}
export class UpdateKpiUserMappingViewModel {
    loggedInUserEmail:string;
    userKpiMasters: UserKpiMasterViewModel[];
}
